<template>
  <div class="animated fadeIn">
    <b-card header="Companies">
      <div slot="header">
        <div class="d-flex justify-content-between">
          <div><strong>Promotions</strong></div>
        </div>
      </div>
      <b-row v-if="admin.level <= 1">
        <b-col md="12" class="pb-4">
          <router-link class="btn btn-primary" to="create">
            <i class="fa fa-plus"></i>&nbsp;Add New
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="my-1">
          <div class="d-flex">
            <div class="pt-1">Per Page:</div>
            <b-form-group class="mb-0 pl-2">
              <b-form-select :options="pageOptions" v-model="perPage" class="mb-1" />
            </b-form-group>
          </div>
        </b-col>
        <b-col md="6" class="my-1">
          <div class="float-right">
            <div class="d-flex">
              <div class="pt-1">Search:</div>
              <b-form-group class="mb-0 pl-2">
                <b-input-group class="mb-1">
                  <b-form-input v-model="filter" placeholder="Type to Search"  />
                </b-input-group>
              </b-form-group>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="row">
        <b-col md="12" class="my-1">
          <b-table show-empty
                   striped
                   responsive="sm"
                   :items="promotions"
                   :fields="fields"
                   :current-page="currentPage"
                   :per-page="perPage"
                   :filter="filter"
                   @filtered="onFiltered"
            >
            <template slot="details" slot-scope="data">
              Name: {{data.value.promotion_name}}<br />
              Company: {{data.value.company_name}}<br />
              Device: {{data.value.device_name}}<br />
              <span v-if="data.value.active" class="green">Active</span>
              <span v-else class="red">Inactive</span>
            </template>
            <template slot="edit" slot-scope="data">
              <router-link class="btn btn-success btn-block" :to="'edit/' + data.item.promotion_id">
                <i class="fa fa-edit"></i>&nbsp;Edit
              </router-link>
            </template>
            <template slot="delete" slot-scope="data">
              <b-button block variant="danger" @click="confirmDelete('promotion', data.item.promotion_id)">
                <i class="fa fa-trash"></i>&nbsp;Delete
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              Showing {{showingFrom}} - {{showingTo}} of {{totalRows}} promotions
            </b-col>
            <b-col md="6" class="my-1">
              <div class="float-right">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </div>
      <b-row v-if="admin.level <= 1">
        <b-col md="12" class="pb-4">
          <router-link class="btn btn-primary" to="create">
            <i class="fa fa-plus"></i>&nbsp;Add New
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <modal name="confirm-delete-promotion" height="auto" :adaptive="true" @before-open="deletePromotionOpen" style="z-index: 10000;">
      <div class="container">
        <b-row class="row-top-delete">
          <b-col xs="10" class="my-1">
            <h2>Delete Promotion</h2>
          </b-col>
          <b-col xs="2" class="my-1">
            <button type="button" class="close" @click="$modal.hide('confirm-delete-promotion')" aria-hidden="true">&times;</button>
          </b-col>
        </b-row>
        <b-row class="row-middle-delete">
          <b-col xs="12" class="my-1">
            <p>Are you sure you want to delete this promotion? This process cannot be undone.</p>
          </b-col>
        </b-row>
        <b-row class="row-bottom-delete">
          <b-col xs="12" class="my-1">
            <div class="d-flex float-right modal-buttons">
              <b-button @click="$modal.hide('confirm-delete-promotion')">Cancel</b-button>
              <button class="btn btn-danger btn-delete" @click="deletePromotion(); $modal.hide('confirm-delete-promotion')">
                Delete
              </button>
            </div>
          </b-col>
        </b-row>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import confirmDelete from './../../mixins/confirmDelete'
import getAdmin from './../../mixins/getAdmin'
import onFiltered from './../../mixins/onFiltered'
import showingFrom from './../../mixins/showingFrom'
import showingTo from './../../mixins/showingTo'

export default {
  name: 'Promotions',
  mixins: [
    confirmDelete,
    getAdmin,
    onFiltered,
    showingFrom,
    showingTo
  ],
  data: () => {
    return {
      admin: {},
      currentPage: 1,
      fields: [
        {key: 'details'},
        {key: 'edit'},
        {key: 'delete'}
      ],
      filter: null,
      pageOptions: [ 5, 10, 15, 20, 25, 50 ],
      perPage: 5,
      promotion_id: 0,
      totalRows: 0
    }
  },
  computed: {
    ...mapGetters([
      'promotions'
    ])
  },
  watch: {
    promotions () {
      this.totalRows = this.promotions.length
    }
  },
  methods: {
    /**
     * Dispatches the deletePromotion action in the Vuex store to soft delete a promotion in the backend API.
     */
    deletePromotion () {
      this.$store.dispatch('deletePromotion', {promotion_id: this.promotion_id, notify: this.$notify})
    },
    /**
     * Function that is evoked when delete modal box is opened.
     * @param {object} event - The event object that is fired.
     */
    deletePromotionOpen (event) {
      this.promotion_id = event.params.id
    },
    /**
     * Dispatches an event to get all the promotions the authenticated admin has access to.
     */
    getAdminPromotions () {
      this.$store.dispatch('getAdminPromotions')
    }
  },
  mounted () {
    this.getAdmin()
    this.getAdminPromotions()
  }
}
</script>
